import { render } from "./DrawerView.vue?vue&type=template&id=4204452d&scoped=true"
import script from "./DrawerView.vue?vue&type=script&lang=js"
export * from "./DrawerView.vue?vue&type=script&lang=js"

import "./DrawerView.vue?vue&type=style&index=0&id=4204452d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4204452d"]])

export default __exports__